var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showMask)?_c('div',{staticClass:"mask",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;!_setup.isWeChat && _setup.toggleView}}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }